import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    tripDaysServiceV1ListTripDaysThresholds: build.query<
      TripDaysServiceV1ListTripDaysThresholdsApiResponse,
      TripDaysServiceV1ListTripDaysThresholdsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-days-thresholds`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          trip_days_threshold_name: queryArg.tripDaysThresholdName,
          duration_condition: queryArg.durationCondition,
          description: queryArg.description,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
          duration: queryArg.duration,
          equivalent_days: queryArg.equivalentDays,
        },
      }),
    }),
    tripDaysServiceV1BatchCreateTripDaysThreshold: build.mutation<
      TripDaysServiceV1BatchCreateTripDaysThresholdApiResponse,
      TripDaysServiceV1BatchCreateTripDaysThresholdApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-days-thresholds`,
        method: "POST",
        body: queryArg.tripDaysV1BatchCreateTripDaysThresholdReq,
      }),
    }),
    tripDaysServiceV1ActivateTripDaysThresholds: build.mutation<
      TripDaysServiceV1ActivateTripDaysThresholdsApiResponse,
      TripDaysServiceV1ActivateTripDaysThresholdsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-days-thresholds/activate`,
        method: "PATCH",
        body: queryArg.tripDaysV1TripDaysBulkStatusChangeReq,
      }),
    }),
    tripDaysServiceV1DeactivateTripDaysThresholds: build.mutation<
      TripDaysServiceV1DeactivateTripDaysThresholdsApiResponse,
      TripDaysServiceV1DeactivateTripDaysThresholdsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-days-thresholds/deactivate`,
        method: "PATCH",
        body: queryArg.tripDaysV1TripDaysBulkStatusChangeReq,
      }),
    }),
    tripDaysServiceV1GetTripDaysThreshold: build.query<
      TripDaysServiceV1GetTripDaysThresholdApiResponse,
      TripDaysServiceV1GetTripDaysThresholdApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/trip-days-thresholds/${queryArg.id}` }),
    }),
    tripDaysServiceV1UpdateTripDaysThreshold: build.mutation<
      TripDaysServiceV1UpdateTripDaysThresholdApiResponse,
      TripDaysServiceV1UpdateTripDaysThresholdApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-days-thresholds/${queryArg.id}`,
        method: "PUT",
        body: queryArg.tripDaysServiceV1UpdateTripDaysThresholdBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as tripDaysApi };
export type TripDaysServiceV1ListTripDaysThresholdsApiResponse =
  /** status 200 A successful response. */ TripDaysV1ListTripDaysThresholdsRes;
export type TripDaysServiceV1ListTripDaysThresholdsApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  tripDaysThresholdName?: string;
  durationCondition?: string;
  description?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
  duration?: string;
  equivalentDays?: string;
};
export type TripDaysServiceV1BatchCreateTripDaysThresholdApiResponse =
  /** status 200 A successful response. */ TripDaysV1TripDaysMessageRes;
export type TripDaysServiceV1BatchCreateTripDaysThresholdApiArg = {
  tripDaysV1BatchCreateTripDaysThresholdReq: TripDaysV1BatchCreateTripDaysThresholdReq;
};
export type TripDaysServiceV1ActivateTripDaysThresholdsApiResponse =
  /** status 200 A successful response. */ TripDaysV1TripDaysBulkStatusChangeRes;
export type TripDaysServiceV1ActivateTripDaysThresholdsApiArg = {
  tripDaysV1TripDaysBulkStatusChangeReq: TripDaysV1TripDaysBulkStatusChangeReq;
};
export type TripDaysServiceV1DeactivateTripDaysThresholdsApiResponse =
  /** status 200 A successful response. */ TripDaysV1TripDaysBulkStatusChangeRes;
export type TripDaysServiceV1DeactivateTripDaysThresholdsApiArg = {
  tripDaysV1TripDaysBulkStatusChangeReq: TripDaysV1TripDaysBulkStatusChangeReq;
};
export type TripDaysServiceV1GetTripDaysThresholdApiResponse =
  /** status 200 A successful response. */ TripDaysV1TripDaysThresholdDetailRes;
export type TripDaysServiceV1GetTripDaysThresholdApiArg = {
  id: string;
};
export type TripDaysServiceV1UpdateTripDaysThresholdApiResponse =
  /** status 200 A successful response. */ TripDaysV1TripDaysMessageRes;
export type TripDaysServiceV1UpdateTripDaysThresholdApiArg = {
  id: string;
  tripDaysServiceV1UpdateTripDaysThresholdBody: TripDaysServiceV1UpdateTripDaysThresholdBody;
};
export type TripDaysV1TripDaysThresholdRes = {
  id?: string;
  trip_days_threshold_name?: string;
  duration_condition?: string;
  duration_min?: number;
  duration_max?: number;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  equivalent_days?: number;
};
export type TripDaysV1TripDaysPaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type TripDaysV1ListTripDaysThresholdsRes = {
  trip_days_thresholds?: TripDaysV1TripDaysThresholdRes[];
  metadata?: TripDaysV1TripDaysPaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type TripDaysV1TripDaysMessageRes = {
  message?: string;
};
export type TripDaysV1CreateTripDaysThresholdItem = {
  trip_days_threshold_name: string;
  duration_condition: string;
  duration_min?: number;
  duration_max?: number;
  description?: string;
  status: string;
  equivalent_days: number;
};
export type TripDaysV1BatchCreateTripDaysThresholdReq = {
  trip_days_thresholds: TripDaysV1CreateTripDaysThresholdItem[];
};
export type TripDaysV1TripDaysBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type TripDaysV1TripDaysBulkStatusChangeReq = {
  ids: string[];
};
export type TripDaysV1TripDaysThresholdDetailRes = {
  id?: string;
  trip_days_threshold_name?: string;
  duration_condition?: string;
  duration_min?: number;
  duration_max?: number;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  equivalent_days?: number;
};
export type TripDaysServiceV1UpdateTripDaysThresholdBody = {
  trip_days_threshold_name: string;
  duration_condition: string;
  duration_min?: number;
  duration_max?: number;
  description?: string;
  equivalent_days: number;
};
export const {
  useTripDaysServiceV1ListTripDaysThresholdsQuery,
  useTripDaysServiceV1BatchCreateTripDaysThresholdMutation,
  useTripDaysServiceV1ActivateTripDaysThresholdsMutation,
  useTripDaysServiceV1DeactivateTripDaysThresholdsMutation,
  useTripDaysServiceV1GetTripDaysThresholdQuery,
  useTripDaysServiceV1UpdateTripDaysThresholdMutation,
} = injectedRtkApi;
